<template>
  <div id="leftEchartsPeople" class="echarts"></div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  watchEffect,
  inject,
  nextTick,
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import * as echarts from "echarts";
import { countByRegion } from "@/api/publicSecurityResearch/drugControlModel.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      nameList: [],
      valuelist: [],
    });
    const refData = toRefs(data);
    const ruleInfo = inject("ruleInfo");
    watchEffect(() => {
      if (ruleInfo.endDate || ruleInfo.startDate) {
        nextTick(() => {
          initCharts();
        });
      }
    });
    const numberall = async () => {
      const parms = {
        libareId: 1,
        endDate: ruleInfo.endDate,
        startDate: ruleInfo.startDate,
      };
      const res = await countByRegion(parms);
      const name = [];
      const value = [];
      res.data.forEach((item, index) => {
        if (index < 6 && item.value !== 0) {
          name.unshift(item.name);
          value.unshift(item.value);
        }
      });
      data.nameList = name;
      data.valuelist = value;
    };
    const initCharts = async () => {
      await numberall();
      const myChart = echarts.init(
        document.getElementById("leftEchartsPeople")
      );
      const option = {
        // title: {
        //   text: "World Population",
        // },
        // tooltip: {
        //   trigger: "axis",
        //   axisPointer: {
        //     type: "shadow",
        //   },
        // },
        legend: {},
        grid: {
          top: 40,
          left: 70,
          right: 30,
          bottom: 50,
          // containLabel: true
        },
        xAxis: {
          splitLine: {
            // 网格线
            lineStyle: {
              color: "#08598f",
              type: "dashed", // 设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, // 隐藏或显示
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
        },

        yAxis: {
          itemStyle: {
            color: "#326e9a",
            borderColor: "#5ea9d0",
          },
          type: "category",
          data: data.nameList, // ["文峰街道", "汉丰街道", "开州大道", "兴合社区", "凤凰社区"],
          axisLabel: {
            formatter: "{value}",
            textStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            // itemStyle: {
            //   color: "#326e9a",
            //   borderColor: "#5ea9d0",
            // },
            barGap: 5 /* 多个并排柱子设置柱子之间的间距 */,
            barWidth: "80%",
            barCateGoryGap: "80%",
            // barWidth: 35,
            type: "bar",
            data: data.valuelist, // [2000, 30000, 60000, 90000, 120000],
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#9aabf3" },
                { offset: 0.5, color: "#5ccdf0" },
                { offset: 1, color: "#4dddf0" },
              ]),
            },
          },
        ],
      };
      myChart.setOption(option, true);
    };
    onMounted(async () => {
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    });
    return { ...refData };
  },
});
</script>
<style lang="scss" scoped>
#leftEchartsPeople {
  width: 100%;
  height: 90%;
}
</style>
